import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { NextPageWithLayout } from '@/layouts/types'
import { ToastProvider } from '@/molecules/Toast/ToastProvider'
import { Page, PageSeo } from '@/page'
import { getPageByPath } from '@/services/CmsService/Pages'
import { PageDataContext, PageModel, fetchPageDataContext } from '@/services/RenderService'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'

interface MoviesPageProps {
  pageDataContext: PageDataContext
  page: PageModel
  locale: string
}

const MoviesPage: NextPageWithLayout<MoviesPageProps> = ({ page, pageDataContext, locale }) => {
  return (
    <>
      <PageSeo page={page} locale={locale} />
      <div className="bg-core-gray-950 pb-10 pt-28 text-white">
        <main className="flex flex-col gap-8">
          <ToastProvider>
            <Page page={page} pageDataContext={{ ...pageDataContext, contentItemConfig: { padding: true } }} />
          </ToastProvider>
        </main>
      </div>
    </>
  )
}

export const getStaticPaths = getGenericStaticPaths

export const getStaticProps = getStaticPropsErrorHandler<MoviesPageProps>(
  { filePath: 'pages/[locale]/movies/index.tsx' },
  async ({ locale, next404, preview, federationClient }) => {
    const [page, translations] = await Promise.all([
      getPageByPath(paths.movies.index, { locale, preview }),
      loadTranslations(locale, ['common', 'account', 'category', 'watch']),
    ])

    const pageDataContext = page ? await fetchPageDataContext(page, preview, locale, federationClient) : null

    if (!page || !pageDataContext) {
      return next404(Durations.FIVE_MINUTES_IN_SECONDS)
    }

    return {
      props: {
        pageDataContext: pageDataContext,
        page,
        locale,
        ...translations,
      },
      revalidate: Durations.FIFTEEN_MINUTES_IN_SECONDS,
    }
  },
)

export default MoviesPage
